// src/components/About/index.js
import React, { Component } from 'react';
import Container from 'react-bootstrap/Container'

class About extends Component {
    render() {
        return (
            <Container>
                <h3>About Me</h3>
                <p>
                    I like basketball <span role="img" aria-label="basketball">🏀</span>, noodle soups <span role="img" aria-label="noodles">🍜</span>, and traveling the world <span role="img" aria-label="noodles">✈️</span>.
                </p>
            </Container>
        );
    }
}

export default About;
